<template>
  <v-container>
    <v-layout row>
      <recipe-filter-chips />
      <v-spacer></v-spacer>
      <base-sort v-model="sort" :columns="columns" />
    </v-layout>
    <recipe-list-item
      v-for="recipe in computedRecipes"
      :key="recipe.id"
      :recipe="recipe"
    />
  </v-container>
</template>

<script>
import RecipeListItem from "@/components/RecipeListItem";
import BaseSort from "@/components/BaseSort";
import { createCompareByProperty } from "@/utils/SortUtils";
import { hasIntersection } from "@/utils/ArrayUtils";
import { SET_SORT } from "@/action-types";
import RecipeFilterChips from "@/components/RecipeFilterChips";
import { containsIgnoreDiacritics } from "@/utils/StringUtils";

export default {
  name: "RecipesPage",
  components: { RecipeFilterChips, BaseSort, RecipeListItem },
  toolbar: {
    title: "Recepty",
    filter: true,
    search: true
  },
  data() {
    return {
      columns: [
        {
          name: "heading",
          title: "Název"
        },
        {
          name: "order",
          title: "Datum vytvoření"
        }
      ]
    };
  },
  computed: {
    computedRecipes() {
      const filteredRecipes = this.recipes.filter(recipe => {
        // Filter by query
        if (
          this.query &&
          !containsIgnoreDiacritics(recipe.heading, this.query)
        ) {
          return false;
        }

        // Filter by tags
        if (
          this.selectedTags.length &&
          !hasIntersection(recipe.tags || [], this.selectedTags)
        ) {
          return false;
        }

        return true;
      });

      console.log(this.sort)

      return filteredRecipes
        .slice() /* make array copy */
        .sort(createCompareByProperty(this.sort.name, this.sort.direction));
    },
    selectedTags() {
      return this.$store.state.filter.tags;
    },
    query() {
      return this.$store.state.filter.query;
    },
    recipes() {
      return this.$store.state.data;
    },
    sort: {
      get() {
        return this.$store.state.sort;
      },
      set(sort) {
        this.$store.commit(SET_SORT, sort);
      }
    }
  }
};
</script>
